import { z } from "zod";
import { UserSchema } from "./User";

export const CreateUserResponseSchema = UserSchema.pick({
    id: true,
})

export type CreateUserResponse = z.infer<typeof CreateUserResponseSchema>;